import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { initializeDataDog } from './app/config/datadog'
import App from './App.tsx'
import './index.css'
import './app/styles/app.css'

// Initialize DataDog RUM if configured
initializeDataDog()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
